// Detect whether the React build is running inside the iOS Capacitor wrapper.
// Used to hide non-Apple-IAP "Upgrade" prompts (App Store Guideline 3.1.1
// requires using Apple In-App Purchase for digital subscriptions; for v1.0 we
// simply hide the Premium upsell on iOS).
import { Capacitor } from '@capacitor/core';

export const isIOSNative = () =>
  typeof window !== 'undefined' &&
  Capacitor.isNativePlatform() &&
  Capacitor.getPlatform() === 'ios';

// Detect whether we're running inside the Android Capacitor wrapper.
export const isAndroidNative = () =>
  typeof window !== 'undefined' &&
  Capacitor.isNativePlatform() &&
  Capacitor.getPlatform() === 'android';

// Convenience: should we show the WEB Stripe upgrade CTAs?
// Returns true ONLY on plain web browsers. On iOS + Android native we drive
// upgrades through the in-app RevenueCat paywall (Apple 3.1.1 + Play §4.5).
export const canShowSubscriptionUpgrade = () => !isIOSNative() && !isAndroidNative();
